import React from 'react'
import { Host } from '@/components/molecules/Host/Host'
import { EventForm } from '@/components/molecules/EventForm/EventForm'
import Check from '@/assets/icons/check-thin.svg'
import { EventAnnouncer } from '../EventAnnouncer/EventAnnouncer'
import { HeroWebinarProps } from './types'

export function HeroWebinar({ event, form, host, topics, background_image, id }: HeroWebinarProps) {
  const eventData = event?.length && event[0]
  const formData = form?.length && form[0]
  const hostData = host?.length && host[0]

  return (
    <section
      className="py-24 netbook:py-64 bg-no-repeat bg-contain bg-center-bottom netbook:bg-center"
      style={{ backgroundImage: `url(${background_image.image})` }}
      id={id}
    >
      <div className="w-full laptop:flex max-w-screen-desktop laptop:px-90 laptop:mx-auto">
        <div className="mb-64">
          {eventData && <EventAnnouncer {...eventData} left />}
          <div className="px-24 max-w-sm mx-auto laptop:ml-0 laptop:px-0">
            {hostData && <Host {...hostData} />}
            {topics.length > 0 ? (
              <div className="mt-48">
                {topics.map((topic) => (
                  <div className="flex mt-24" key={topic._uid}>
                    <img src={Check} width="16px" alt={topic.text} />
                    <p className="font-poppins font-bold text-bodyL ml-20">{topic.text}</p>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
        <div className="max-w-44 mx-auto laptop:mr-0 laptop:w-[540px]">{formData && <EventForm {...formData} />}</div>
      </div>
    </section>
  )
}
